import { PluginCard, PluginCardCommonProps } from '../../../plugins-tab/PluginCard';
import { PluginBantSvg } from '../../icons';
import { bantTexts } from './texts';

export const BantPluginCard = (props: PluginCardCommonProps) => {
  return (
    <PluginCard
      svgIcon={<PluginBantSvg />}
      title={bantTexts.title}
      description={bantTexts.description}
      {...props}
    />
  );
};
